export function gens() {
    const ScrollByAnimationTarget = document.getElementsByClassName('js-scroll');
    const AddClassPosition = Math.floor(window.innerHeight * 0.9);
    for (let i = 0; i < ScrollByAnimationTarget.length; i++) {
        const offsetTop = Math.floor(ScrollByAnimationTarget[i].getBoundingClientRect().top);
        if (offsetTop < AddClassPosition) {
            ScrollByAnimationTarget[i].classList.add('js-active');
        }
    }
}
